var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-products items-list search-list view-all__list"},_vm._l((_vm.infiniteLoadingValues),function(item,index){return _c('Products',{key:`${index}::${item.productId}`,staticClass:"search-list__item items-list__item",attrs:{"type":"viewall","item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }